import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-card-popover',
  imports: [],
  templateUrl: './card-popover.component.html',
  styleUrl: './card-popover.component.scss'
})
export class CardPopoverComponent {

  @Input() timeInView: number = 0;
  @Input() viewability: number = 0;
}
